import { connect } from "react-redux";
import { form } from "MODULES/shared/components/Forms";
import withRma from "MODULES/RMAsAndWarranties/decorators/withRma";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import Form from "./Form";

export default withRma(
  connect(undefined, (dispatch, ownProps) => ({
    onSubmit: values =>
      dispatch(actions.update(values, ownProps.setForceOpenShipTo))
  }))(
    form({
      form: "rmaVendorDetails"
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Details/EditVendorDetails.jsx